import React from "react";
import styled from "styled-components";
import { bulletIcon } from "../../../assets/icons";
import { Button } from "../..";

export default function ProgramsCards({ data }) {
	return (
		<ProgramsCardsContainer>
			{data.map(({ title, description }, i) => (
				<li className="program-card" id={i}>
					<div>
						<img src={bulletIcon} alt="bullet" />
					</div>

					<div className="details">
						<h4>{title}</h4>
						<div className="description-container">
							<p className="text-justify">{description}</p>
							<Button linkTo="/get-involved" transparent>
								Get Involved
							</Button>
						</div>
					</div>
				</li>
			))}
		</ProgramsCardsContainer>
	);
}

const ProgramsCardsContainer = styled.ul`
	li {
		margin-bottom: 2rem;

		&:last-child {
			margin-bottom: 0;
		}

		img {
			width: 2rem;
			height: 14px;
		}

		.details {
			display: flex;

			h4 {
				width: 22%;
				font-weight: bold;
				margin-right: 3rem;
			}

			.description-container {
				width: 70%;
			}
		}
	}
`;
